// ExpressEntry.tsx
import React from 'react';

const ExpressEntry: React.FC = () => {
    return (
        <iframe
            src="https://express-entry-draws.vercel.app/"
            title="Express Entry Draws"
            style={{
                width: '100%', // Full width of the container
                height: 'calc(100vh - 50px)', // Full height of the viewport minus the header's height
                border: 'none', // No border for the iframe
            }}
        />
    );
};

export default ExpressEntry;
